import { render, staticRenderFns } from "./communityDetail.vue?vue&type=template&id=2f68ccbe&scoped=true&"
import script from "./communityDetail.vue?vue&type=script&lang=js&"
export * from "./communityDetail.vue?vue&type=script&lang=js&"
import style0 from "./communityDetail.vue?vue&type=style&index=0&id=2f68ccbe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f68ccbe",
  null
  
)

export default component.exports